import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

import type { PropsWithChildren } from 'react';

import LoadingCover from '@/components/Layouts/Loading';
import { usesMomentsScheduling } from '@/features/appointments/schedulingProvider';
import { isCoach } from '@/types/user';

// MEN-5635: routes that book as the signed-in coach on Moments. Like the coach
// schedule, they need Moments scheduling: a coach still on Cal must not create
// native appointments. Moments separately refuses a caller who is not the
// selected pair's matched coach.
const RequireCoach = ({ children }: PropsWithChildren) => {
  const { user, isUserLoading } = useCurrentUser();
  const navigate = useNavigate();

  const allowed =
    Boolean(user.id) && isCoach(user) && usesMomentsScheduling(user);

  useEffect(() => {
    if (!isUserLoading && !allowed) {
      navigate('/coach/schedule', { replace: true });
    }
  }, [allowed, isUserLoading, navigate]);

  if (isUserLoading) return <LoadingCover />;

  return allowed ? children : null;
};

export default RequireCoach;
